import { createContext } from 'react'

const defaultContext = {
}

const AppContext = createContext( defaultContext )
export default AppContext
